import { Link } from 'react-router-dom';
import { Clock, Sparkles } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { differenceInDays, format } from 'date-fns';

interface TrialBannerProps {
  trialEndDate: string;
}

export function TrialBanner({ trialEndDate }: TrialBannerProps) {
  const endDate = new Date(trialEndDate);
  const today = new Date();
  const daysRemaining = Math.max(0, differenceInDays(endDate, today));
  
  const isUrgent = daysRemaining <= 3;
  const formattedEndDate = format(endDate, 'MMMM d, yyyy');

  return (
    <div 
      className={`w-full py-2 px-4 flex items-center justify-between gap-4 text-sm ${
        isUrgent 
          ? 'bg-amber-500/10 border-b border-amber-500/20' 
          : 'bg-primary/5 border-b border-primary/10'
      }`}
    >
      <div className="flex items-center gap-2">
        <Clock className={`w-4 h-4 ${isUrgent ? 'text-amber-500' : 'text-primary'}`} />
        <span className="text-foreground">
          <span className="font-medium">Free trial</span>
          {' – '}
          <span className={isUrgent ? 'text-amber-600 font-medium' : 'text-muted-foreground'}>
            {daysRemaining === 0 
              ? 'Ends today' 
              : daysRemaining === 1 
                ? '1 day remaining' 
                : `${daysRemaining} days remaining`}
          </span>
          <span className="text-muted-foreground hidden sm:inline">
            {' '}(ends {formattedEndDate})
          </span>
        </span>
      </div>
      
      <Link to="/pricing">
        <Button 
          size="sm" 
          variant={isUrgent ? 'default' : 'outline'}
          className="gap-1.5"
        >
          <Sparkles className="w-3.5 h-3.5" />
          Upgrade now
        </Button>
      </Link>
    </div>
  );
}
